<script>
  export let setPage;
</script>

<div class="complete-container">
  <div class="complete-box">
    <div class="logo">
      <h1>WIDE-WORK</h1>
    </div>
    
    <h2>회원가입 완료</h2>
    
    <div class="signup-step">
      <span class="step">1. 약관동의</span>
      <span class="step-divider">></span>
      <span class="step">2. 정보입력</span>
      <span class="step-divider">></span>
      <span class="step active">3. 가입완료</span>
    </div>
    
    <div class="complete-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="100" height="100" fill="#3273dc">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
      </svg>
    </div>
    
    <div class="complete-message">
      <h3>WIDE-WORK 회원가입이 완료되었습니다!</h3>
      <p>회원가입해 주셔서 감사합니다.<br>다양한 서비스를 이용하실 수 있습니다.</p>
    </div>
    
    <div class="button-group">
      <button class="home-btn" on:click={() => setPage('home')}>홈으로</button>
      <button class="login-btn" on:click={() => setPage('login')}>로그인</button>
    </div>
  </div>
</div>

<style>
  .complete-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background-color: #f9f9f9;
    font-family: 'Noto Sans KR', sans-serif;
    padding: 40px 20px;
  }
  
  .complete-box {
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    padding: 40px;
    width: 100%;
    max-width: 600px;
    text-align: center;
  }
  
  .logo {
    text-align: center;
    margin-bottom: 20px;
  }
  
  .logo h1 {
    color: #3273dc;
    font-size: 2.2rem;
    font-weight: 700;
  }
  
  h2 {
    font-size: 1.8rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 30px;
  }
  
  .signup-step {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
  }
  
  .step {
    padding: 8px 15px;
    font-size: 0.9rem;
    color: #999;
  }
  
  .step.active {
    color: #3273dc;
    font-weight: 500;
  }
  
  .step-divider {
    color: #ccc;
    margin: 0 5px;
  }
  
  .complete-icon {
    margin: 30px 0;
  }
  
  .complete-message {
    margin-bottom: 40px;
  }
  
  .complete-message h3 {
    font-size: 1.4rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 15px;
  }
  
  .complete-message p {
    color: #666;
    line-height: 1.6;
    font-size: 1rem;
  }
  
  .button-group {
    display: flex;
    justify-content: center;
    gap: 15px;
  }
  
  .home-btn {
    background-color: #f0f0f0;
    color: #666;
    border: none;
    border-radius: 5px;
    padding: 14px 30px;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
  }
  
  .home-btn:hover {
    background-color: #e4e4e4;
  }
  
  .login-btn {
    background-color: #3273dc;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 14px 30px;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
  }
  
  .login-btn:hover {
    background-color: #2860b5;
  }
  
  @media (max-width: 768px) {
    .complete-box {
      padding: 30px 20px;
    }
    
    .button-group {
      flex-direction: column;
    }
    
    .home-btn, .login-btn {
      width: 100%;
    }
  }
</style> 